import React from 'react';
import { connect, useSelector } from 'react-redux';
import BeforeCallImportantInfoWaitingArea from '../components/pages/waiting-area/before-calls-important-info/content';

function WaitingAreaBeforeCallsImportantInfoPage(props) {
  const showBeforeCallsImportantInfoModal = useSelector(
    (state) => state.modalReducer.showBeforeCallsImportantInfoModal
  );
  const beforeCallsImportantInfoForm = useSelector((state) => state.waitingAreaReducer.beforeCallsImportantInfoForm);

  return (
    <div>
      <BeforeCallImportantInfoWaitingArea
        waitingArea={props.waitingArea}
        beforeCallsImportantInfoForm={beforeCallsImportantInfoForm}
        showBeforeCallsImportantInfoModal={showBeforeCallsImportantInfoModal}
        updateOrView={props.updateOrView}
      />
    </div>
  );
}

export default WaitingAreaBeforeCallsImportantInfoPage;
